import { extend } from 'vee-validate';
import { required, alpha_num } from 'vee-validate/dist/rules';


export function registerRequiredValidator(message: string) {
  extend('required', {
    ...required,
    message
  });
}

export function registerAlphaNumValidator(message: string) {
  extend('alpha_num', {
    ...alpha_num,
    message
  });
}